import { Button } from 'antd';
import { CSSProperties, ReactNode } from 'react';

const RoundedButtonWithBorder = ({
   children,
   onClick,
   className,
   style,
   fontSize,
   ...props
}: {
   children: ReactNode;
   onClick?: React.MouseEventHandler<HTMLElement> | undefined;
   className?: string;
   style?: CSSProperties;
   [x: string]: any;
   fontSize?: number;
}) => {
   return (
      <Button
         color="default"
         shape="round"
          {...(className ? { className } : {})}
          onClick={onClick}
          style={{
            fontWeight: 400,
            fontSize: fontSize ? fontSize : 14,
            ...style,
          }}
         {...props}
      >
         {children}
      </Button>
   );
};
export default RoundedButtonWithBorder;
